// extracted by mini-css-extract-plugin
export default {"faqAgentPage":"faqAgentPage_B94jd","container":"container_a9BtB","breadcrumbs":"breadcrumbs_uOEj5"};